import { DividerDesignTokens } from '@primeuix/themes/types/divider';

export const Divider: DividerDesignTokens = {
  colorScheme: {
    dark: {
      content: {
        background: '{surface.50}',
      },
    },
  },
};
